import React, { FC, useState, useEffect, Fragment } from 'react';
import { ReactComponent as CsvIcon } from 'assets/icons/csv-icon.svg';
import { ActiveType, MemberType } from './types';
import XlsInfoModal from 'components/xls-info-modal';

type CsvFileProps = {
  description: string;
  setMembers: (members: MemberType[]) => void;
  setActive: (item: ActiveType) => void;
  setFile: (item: File | null) => void;
  file: File | null;
};

const AddCsvFile: FC<CsvFileProps> = ({ description, setMembers, setActive, setFile, file }) => {
  const [showXlsInfoModal, setShowXlsInfoModal] = useState(false);
  const handleFileDrop = (e: React.DragEvent<HTMLDivElement>) => {
    setActive('xls');
    e.preventDefault();
    const files = e.dataTransfer.files;
    if (files) setFile(files[0]);
  };
  const memberAdditionDetails = {
    title: 'Adding Members via XLS file',
    subtitle:
      'Welcome to the Member addition process via XLS file. Please Follow these steps to ensure a smooth member addition:',
    steps: [
      {
        number: 1,
        heading: 'Download the Template',
        description: "Click the 'Download XLS Template' button to obtain the template file."
      },
      {
        number: 2,
        heading: "Fill in Company Enrollees' Details",
        description:
          ' Open the downloaded XLS file, Specify the role of each enrollee by entering "Admin" or "Member" in the "Role" column. Enter the date of birth for each enrollee in the format "Day / Month / Year."'
      },
      {
        number: 3,
        heading: 'Save Your Changes',
        description: 'Save the XLS file with your entries'
      },
      {
        number: 4,
        heading: 'Review',
        description:
          'Crosscheck the details in the XLS file. Click confirm to select the file and upload'
      },
      {
        number: 5,
        heading: 'Verify the details',
        description:
          'After uploading, the details will be displayed for final review before addition,then click continue to add members to the company'
      }
    ]
  };
  const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault();
  };

  const reset = () => {
    setActive('xls');
    setMembers([]);
  };
  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      setFile(e.target.files[0]);
    }
  };

  useEffect(() => {
    if (file) {
      setShowXlsInfoModal(!XlsInfoModal);
    }
  }, [file]);

  return (
    <Fragment>
      <div
        onClick={() => {
          setShowXlsInfoModal(true);
        }}
        onDrop={handleFileDrop}
        onDragOver={handleDragOver}
        className={`border w-full sm:w-[185px] h-[139px] border-[#EAEBEB] hover:border-[#E60A2B] cursor-pointer hover:border-[1.5px] p-4 rounded-md space-y-3`}>
        <div className='border border-[#EAEBEB] p-2 rounded-full w-9 h-9 flex items-center'>
          <CsvIcon />
        </div>
        <h2 className='text-sm font-semibold'>Add via .xls</h2>
        <p className='text-[#6F7376] text-xs font-normal '>{description} </p>
      </div>
      <XlsInfoModal
        title={memberAdditionDetails.title}
        show={showXlsInfoModal}
        onClose={() => setShowXlsInfoModal(false)}
        handleFileUpload={handleFileUpload}
        handleFileChange={reset}
        downloadLink='https://docs.google.com/spreadsheets/d/1kDDaRsBQork-Dh0akz7wFz8seqmRPmTcE0Cjp1WRqPQ/export?format=xlsx'>
        <div className='w-full max-w-[400px]'>
          <h2 className='text-sm text-[#2E3031]'>{memberAdditionDetails.subtitle}</h2>
          <div>
            {memberAdditionDetails.steps.map((step) => (
              <div className='flex items-center max-w-[400px]' key={step.number}>
                <div className='number-container'>
                  <span className='number mb-2 mr-2'>{step.number}</span>
                </div>
                <span className='mt-3'>
                  <h3 className='text-sm font-medium '>{step.heading}</h3>
                  <p className='text-xs'>{step.description}</p>
                </span>
              </div>
            ))}
          </div>
        </div>
      </XlsInfoModal>
    </Fragment>
  );
};

export default AddCsvFile;
